import enqueueWithHTLBid from './enqueueWithHTLBid';

export default function updateDfpCorrelator() {
  enqueueWithHTLBid(() => {
    window.htlbid.pubads().updateCorrelator();
  });
}
